import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillsSummaryWrapper = styled.section`
  margin-bottom: ${Spacing.S32};
`

export const BillsSummaryTitleWrapper = styled.section`
  display: flex;
  align-items: center;
`

export const BillsSummaryTooltipWrapper = styled.section`
  margin-left: ${Spacing.S8};
`
